$(function () {
    jQuery.validator.addMethod("domain", function (value, element) {
        if (value.indexOf('localhost') !== -1) {
            return true;
        }
        return this.optional(element) || /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(value);
    }, "Domain is invalid.");

    $('#loginForm').validate(extendValidationSettings({
        rules: {
            OrganizationDomain: {
                required: true,
                domain: true
            }
        },
        messages: {
            OrganizationDomain: {
                required: 'Domain is required.',
                domain: 'Domain is invalid.'
            }
        }
    }));
});